import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  labelPoi: '',
  idImageView: null,
  loadingView: true,
  typePoiSelected: 'street',
  expandInfoMobile: true
};

const poiSlice = createSlice({
  name: 'poi',
  initialState,
  reducers: {
    openInfoPoi: (state) => {
      state.open = true;
      state.expandInfoMobile = true;
    },
    closeInfoPoi: (state) => {
      state.open = false;
    },
    setLabelPoi: (state, action) => {
      state.labelPoi = action.payload;
    },
    setBoundsPoi: (state, action) => {
      state.bounds = action.payload;
    },
    setLoadingImage: (state, action) => {
      state.loadingView = action.payload;
    },
    setIdViewImage: (state, action) => {
      state.idImageView = action.payload;
    },
    setTypePoiSelected: (state, action) => {
      state.typePoiSelected = action.payload;
    },
    openInfoMobile: (state) => {
      state.expandInfoMobile = true;
    },
    closeInfoMobile: (state) => {
      state.expandInfoMobile = false;
    },
    resetPoi: () => initialState
  }
});

export const { 
  setLabelPoi, 
  setTypePoiSelected, 
  openInfoPoi, 
  setBoundsPoi,
  setLoadingImage,
  setIdViewImage,
  closeInfoPoi, 
  openInfoMobile,
  closeInfoMobile,
  resetPoi 
} = poiSlice.actions;

export default poiSlice.reducer;